import { isProductInCachedBasket } from "@~/utils/product";
import { useCachedBasketData } from "../__shared__/AddToBasketUtils/hooks/useCachedBasket";
import { productCardEvents } from "@~/contexts/ProductCardEventContext/productCardEvents";
import { SecondaryButton as V31SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { SecondaryButton as DeprecatedSecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import styles from "./CallToAction.module.scss";
import { useProductCardEvent } from "@~/contexts/ProductCardEventContext/ProductCardEventContext";
import { AddToBasketButton } from "./AddToBasketButton/AddToBasketButton";
import { Product } from "@~/types/types";
declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    jlData: any;
  }
}

interface BasketButtonProps {
  product: Product;
  configProps: Record<string, unknown> | undefined;
  title: string;
  isJldsV31Enabled: boolean;
  hasGoToBasketButton: boolean;
  clientId: string;
  isMultiSku: boolean;
  showQuickView: () => void;
}

export function BasketButton({
  product,
  configProps,
  title,
  isJldsV31Enabled,
  hasGoToBasketButton,
  clientId,
  isMultiSku,
  showQuickView,
}: BasketButtonProps) {
  const cachedBasketData = useCachedBasketData();
  const dispatchEvent = useProductCardEvent();

  const atbButtonText = `Go to ${!configProps?.shortATBText ? "your" : ""} basket`;
  const isBasketPageType =
    typeof window !== "undefined"
      ? window.jlData?.page?.pageInfo?.pageType === "shopping basket"
      : false;

  const isProductInBasket = isProductInCachedBasket(
    product.aliases?.pimProductId,
    cachedBasketData,
  );

  if (hasGoToBasketButton && isProductInBasket && !isBasketPageType) {
    return isJldsV31Enabled ? (
      <V31SecondaryButton
        className={styles.cta_button}
        aria-label={`${title} is in your basket. Go to basket`}
        href="/basket"
        size="small"
        tag="a"
        labelText={`${atbButtonText}`}
        onClick={() => {
          dispatchEvent(productCardEvents.ctaGoToBasket);
        }}
      />
    ) : (
      <DeprecatedSecondaryButton
        className={styles.cta_button}
        aria-label={`${title} is in your basket. Go to basket`}
        href="/basket"
        size="small"
        tag="a"
        onClick={() => {
          dispatchEvent(productCardEvents.ctaGoToBasket);
        }}
      >
        {atbButtonText}
      </DeprecatedSecondaryButton>
    );
  }

  return (
    <AddToBasketButton
      className={styles.cta_button}
      product={product}
      longCtaText={configProps?.longCtaText === true}
      clientId={clientId}
      handleMultiSku={isMultiSku ? showQuickView : undefined}
    />
  );
}
